// Helper cellRenderer untuk tombol aksi ag-grid di fitur Inspection.
// Dipakai di Index.vue (list header) dan InspectionDetailModal.vue (list item).
// Class custom murni (bukan vs-button bawaan Vuesax) supaya ukuran ringkas
// dan tidak konflik dengan padding/border-radius default Vuesax.

export function renderExportButton(id) {
    return `
        <button
            class="inspection-action-btn inspection-action-btn--success"
            data-action="export"
            data-id="${id}"
            title="Export"
        >
            <i class="material-icons">file_download</i>
            <span>Export</span>
        </button>
    `;
}

export function renderDeleteButton(id) {
    return `
        <button
            class="inspection-action-btn inspection-action-btn--danger"
            data-action="delete"
            data-id="${id}"
            title="Delete"
        >
            <i class="material-icons">delete</i>
            <span>Delete</span>
        </button>
    `;
}

export function findActionTarget(event) {
    if (!event || !event.target) return null;
    return event.target.closest("[data-action]");
}
